import Layout from '../../components/layout';

import { graphql } from 'gatsby';
import React from 'react';

import Footer from '../../components/footer/footer';
import Navbar from '../../components/navbar/navbar';
import NineteenArticle from '../../components/nineteen/nineteen-article/nineteen-article';
import NineteenBanner from '../../components/nineteen/nineteen-banner/nineteen-banner';
import NineteenFooter from '../../components/nineteen/nineteen-footer/nineteen-footer';
import NineteenHeroImage from '../../components/nineteen/nineteen-hero-image/nineteen-hero-image';
import NineteenHero from '../../components/nineteen/nineteen-hero/nineteen-hero';
import NineteenHighlights from '../../components/nineteen/nineteen-highlights/nineteen-highlights';
import NineteenInsights from '../../components/nineteen/nineteen-insights/nineteen-insights';
import NineteenQuote from '../../components/nineteen/nineteen-quote/nineteen-quote';
import NineteenSocialProof from '../../components/nineteen/nineteen-social-proof/nineteen-social-proof';
import NineteenTextCta from '../../components/nineteen/nineteen-text-cta/nineteen-text-cta';
import {
  Drupal_FieldNodeNineteenFieldNineteenParagraphs,
  Drupal_NodeNineteen,
  Drupal_Paragraph
} from '../../generated/graphql';
import {
  useMenuDefaultFooter,
  useMenuMainNavLinks
} from '../../hooks/use-menu';
import { TemplateProps } from '../../types/types';
import './nineteen.scss';
import { getEntityFields } from '../../utils/getEntityFields';

const Nineteen = ({ data, pageContext, location }: TemplateProps) => {
  const { langPrefix, pageType, nid, hideSsr } = pageContext;

  const { drupal } = data;
  const node = drupal.nodeById as Drupal_NodeNineteen;
  const { entityMetatags, entityTranslations } = getEntityFields(node);

  const componentMapping: { [key: string]: any } = {
    nineteen_article: NineteenArticle,
    nineteen_banner: NineteenBanner,
    nineteen_footer: NineteenFooter,
    nineteen_hero: NineteenHero,
    nineteen_hero_image: NineteenHeroImage,
    nineteen_highlights: NineteenHighlights,
    nineteen_insights: NineteenInsights,
    nineteen_quote: NineteenQuote,
    nineteen_social_proof: NineteenSocialProof,
    nineteen_text_cta: NineteenTextCta
  };

  const nineteenParagraphs = node.fieldNineteenParagraphs as Drupal_FieldNodeNineteenFieldNineteenParagraphs[];

  const navbarMenu = useMenuMainNavLinks(langPrefix);
  const footerMenu = useMenuDefaultFooter(langPrefix);

  return (
    <Layout
      pageType={pageType}
      location={location}
      langPrefix={langPrefix}
      metatags={entityMetatags}
      entityTranslations={entityTranslations}
      nid={nid}
      trackers={{
        personas: node.fieldPersona,
        integrationCompanies: node.fieldIntegrationCompany
      }}
      hideSsr={hideSsr}
    >
      {node.fieldHasNavbar && <Navbar menu={navbarMenu} scrollDistance={1} />}
      <main
        className={`nineteen ${
          !node.fieldHasNavbar ? 'nineteen--no-navbar' : ''
        }`}
      >
        {nineteenParagraphs.map(({ entity }) => {
          const { entityBundle, entityId } = entity as Drupal_Paragraph;
          const NineteenComponent = componentMapping[entityBundle as string];

          return NineteenComponent ? (
            <NineteenComponent key={entityId} entity={entity} />
          ) : null;
        })}
      </main>
      {node.fieldHasFooter && (
        <Footer
          menu={footerMenu}
          entityTranslations={entityTranslations}
          padFooter
        />
      )}
    </Layout>
  );
};

export default Nineteen;

export const query = graphql`
  query($nid: String!, $LanguageId: Drupal_LanguageId!) {
    drupal {
      nodeById(id: $nid, language: $LanguageId) {
        ... on Drupal_NodeNineteen {
          ...entityFields
          fieldHasNavbar
          fieldHasFooter
          fieldNineteenParagraphs {
            entity {
              entityId
              entityBundle
              ...nineteenArticle
              ...nineteenBanner
              ...nineteenFooter
              ...nineteenHero
              ...nineteenHeroImage
              ...nineteenHighlights
              ...nineteenInsights
              ...nineteenQuote
              ...nineteenTextCta
            }
          }
          fieldPersona {
            entity {
              entityLabel
            }
          }
          fieldIntegrationCompany {
            entity {
              entityLabel
            }
          }
        }
      }
    }
  }
`;
